import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CallServiceAbstract } from "../call.service";
import { SettingsService } from "../../settings.service";
import { AuthenticationService } from "../../auth/Authentication/authentication.service";
import { Subject } from 'rxjs';
import { NotificationService } from '../../notification.service';
import { StateService } from '../../state/state.service';

@Injectable({
    providedIn: 'root'
})

export class CrmSalesSalesOrderLine extends CallServiceAbstract {
    constructor(
        http: HttpClient,
        settings: SettingsService,
        authentication: AuthenticationService,
        notify: NotificationService,
        state: StateService,
    ) {
        super(http, settings, authentication, notify, state, 'Crm_Sales_SalesOrderLines', 'Редове от продажби');
    }

    public predefineState(state) {
        state = super.predefineState(state);
        state.expand.push('SalesOrder($select=Id,DocumentDate,DocumentNo)');

        state.select = [
            "QuantityBase",
            "UnitPrice",
        ];
        state.take = 200000;

        return state;
    }

    public findByProduct(id, from, to) {
        let call = JSON.parse(JSON.stringify(this.stateTemplate));
        call.filter.filters.push({ field: 'SalesOrder/DocumentDate', operator: 'ge', value: from.format('YYYY-MM-DD')+'T00:00:00Z' });
        call.filter.filters.push({ field: 'SalesOrder/DocumentDate', operator: 'le', value: to.format('YYYY-MM-DD')+'T00:00:00Z' });
        call.filter.filters.push({ field: 'SalesOrder/State', operator: 'eq', value: "'Released'" });
        call.filter.filters.push({ field: 'SalesOrder/Void', operator: 'eq', value: "false" });
        call.filter.filters.push({ field: 'SalesOrder/AdjustedDocument', operator: 'eq', value: "null" })
        call.filter.filters.push({ field: 'Product', operator: 'eq', value: "'General_Products_Products("+id+")'" });
        return this.filter(call)
    }

    filter(filter) {
        let obz = new Subject();
        this.query(filter).subscribe(
            data => obz.next(data),
            err => obz.error(err)
        );
        return obz.asObservable();
    }
}